import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import { useFieldArray, useWatch } from 'react-hook-form'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import styles from './HFInputs.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { AppointmentStatus } from 'utils/enums'
import HFAppointmentProtocolRow from './HFAppointmentProtocolRow'

export const APPOINTMENT_APPROVED_STATES = [
	AppointmentStatus.Scheduled,
	AppointmentStatus.Executed,
	AppointmentStatus.Approved,
]

const HFAppointmentProtocol = (props) => {
	const { name, data } = props

	const { i18n } = useGlobal()

	const { processId, medicalSpecialties, appointments = [] } = data

	const { fields, append, remove } = useFieldArray({
		name,
		keyName: 'key',
	})

	const protocolAppointments = useWatch({ name })

	return (
		<>
			<HStack gap='small' columns={['75px', 4, 4]}>
				<small className={styles['quantity-container']}>
					<strong>{i18n`Qtd.`}</strong>
				</small>
				<small>
					<strong>{i18n`Expertise`}</strong>
				</small>
				<small>
					<strong>{i18n`Provider`}</strong>
				</small>
			</HStack>
			{fields.map(({ key }, index) => {
				const specialtyId = protocolAppointments[index]?.specialtyId

				const totalAppointmentsForSpecialty =
					appointments?.filter(
						(a) =>
							APPOINTMENT_APPROVED_STATES.includes(
								a.status?.id
							) &&
							parseInt(a.medicalSpecialty?.id, 10) ===
								parseInt(specialtyId, 10)
					).length ?? 0

				return (
					<HFAppointmentProtocolRow
						key={key}
						name={name}
						index={index}
						totalAppointmentsForSpecialty={
							totalAppointmentsForSpecialty
						}
						medicalSpecialties={medicalSpecialties}
						remove={remove}
						processId={processId}
					/>
				)
			})}
			<ActionButton
				className={styles['add-appointment-protocol']}
				secondary
				onClick={(e) => {
					e.preventDefault()
					append({
						quantity: 1,
						specialtyId: '',
						serviceProviderId: '',
					})
				}}
			>
				<Icon name='plus' height='14px' width='14px' />
				<small>{i18n`Add`}</small>
			</ActionButton>
		</>
	)
}

export default HFAppointmentProtocol
